import apiClient from "./baseService";
import {handleAxiosError} from "./axiosErrorHandler";
import {Irritile} from "../types/domain/irritiles";
import {Field} from "../types/domain/field";
import {Order} from "../types/domain/order";

export const getIrritiles = async (): Promise<Irritile[]> => {
    return await apiClient
        .get<Irritile[]>("/irritiles")
        .then((res) => res.data)
        .catch(handleAxiosError);
};

export const getIrritileById = async (id: string): Promise<Irritile> => {
    return await apiClient
        .get<Irritile>(`/irritiles/${id}`)
        .then((res) => res.data)
        .catch(handleAxiosError);
};

export const getIrritileFields = async (id: string): Promise<Field[]> => {
    return await apiClient
        .get<Field[]>(`/irritiles/${id}/fields`)
        .then((res) => res.data)
        .catch(handleAxiosError);
};

export const getIrritileOrders = async (id: string): Promise<Order[]> => {
    return await apiClient
        .get<Order[]>(`/irritiles/${id}/orders`)
        .then((res) => res.data)
        .catch(handleAxiosError);
};

export const getFieldsAroundIrritile = async (id: string): Promise<Field[]> => {
    return await apiClient
        .get<Field[]>(`irritiles/${id}/fields-around`)
        .then((res) => res.data)
        .catch(handleAxiosError);
};

export const getIrritilesAroundIrritile = async (id: string): Promise<Irritile[]> => {
    return await apiClient
        .get<Irritile[]>(`irritiles/${id}/irritiles-around`)
        .then((res) => res.data)
        .catch(handleAxiosError);
};
